var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import { generateSrc } from "./generateSrc";
import { generateSrcSet } from "./generateSrcSet";
var generatePictureProps = /* @__PURE__ */ __name(function generatePictureProps2(cdn, _ref) {
  var image = _ref.image, sizesList = _ref.sizesList, artDirectionConfig = _ref.artDirectionConfig;
  var sizes = sizesList.sizes, defaultSrcDimension = sizesList.defaultSrcDimension, _sizesList$fixedBy = sizesList.fixedBy, fixedBy = _sizesList$fixedBy === void 0 ? "width" : _sizesList$fixedBy;
  if (!image.key) {
    return null;
  }
  var fixedByWidth = fixedBy !== "height";
  var maxImageDimension = fixedByWidth ? image.width : image.height;
  var maxSrcDimension = !defaultSrcDimension || maxImageDimension < defaultSrcDimension ? maxImageDimension : defaultSrcDimension;
  return {
    src: generateSrc(cdn, {
      key: image.key,
      width: fixedByWidth ? maxSrcDimension : "AUTO",
      height: fixedByWidth ? "AUTO" : maxSrcDimension,
      extension: image.extension
    }, {
      artDirectionConfig,
      maxImageDimension,
      fixedBy
    }),
    srcSet: {
      img: generateSrcSet(cdn, image.key, image.extension, artDirectionConfig, maxImageDimension, fixedBy).toString(),
      webp: generateSrcSet(cdn, image.key, "webp", artDirectionConfig, maxImageDimension, fixedBy).toString()
    },
    sizes
  };
}, "generatePictureProps");
export {
  generatePictureProps
};
